import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, CircularProgress } from '@mui/material';
import Filters from 'src/components/Items/Filters';
import VanCard from 'src/pages/Van/components/item/index';
import FeedbackCard from '../Van/components/Modal/HostModal/components/Feedback';
import MainHostInfo from '../Van/components/Modal/HostModal/components/MainInfo';
import ExtrasHost from '../Van/components/Modal/HostModal/components/Extras';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { initFilter } from 'src/store/reducers/van';
import './styles.scss';
import './media.scss';

const HostPage: FC = () => {
  const { getHost, getLocations, setStartDateFilter, setEndDateFilter, setupFilters } =
    useActions();
  const { id } = useParams();
  // const container = document.getElementsByClassName('host-page__vans')[0];
  const host = useTypedSelector(state => state.host.host);
  const isLoadingGetHost = useTypedSelector(state => state.host.isLoading.get);
  // const { vanList, checkFilter, filters, errors, isFilterValidate, isLoading } = useTypedSelector(
  //   state => state.van
  // );

  useEffect(() => {
    if (id) {
      getHost(id);
      // getLocations();
      // setupFilters({
      //   ...initFilter,
      //   tags: [id.toUpperCase()]
      // });
    }
  }, [id]);

  return (
    <div className='host-page'>
      {isLoadingGetHost ? (
        <div className='host-page__loading'>
          <CircularProgress size={100} />
        </div>
      ) : (
        host && (
          <div className='host-page__wrapper'>
            <div className='host-page__top'>
              <MainHostInfo host={host} />
              <div className='hostModal__top__description'>
                <h4>Hi, I am {host.first_name}</h4>
                <h6>Thanks for considering us for your next Sprinter Van Trip!</h6>
                <p>{host.description}</p>
                <div className='host-page__top__info'>
                  <ExtrasHost />
                </div>
              </div>
            </div>
            {host.feedback.length ? (
              <>
                <div className='host-page__review-title'>
                  <p>There are good things to talk about {host.first_name}</p>
                </div>
                <div className='host-page__reviews'>
                  {host.feedback.map((el, i) => (
                    <FeedbackCard feedback={el} key={i} />
                  ))}
                </div>
              </>
            ) : (
              <></>
            )}
            {/* <div className='host-page__vans'>
              <p className='host-page__vans__title'>{host.first_name}'s Vehicles</p>
              <div className='host-page__vans__search'>
                <div className='singleVan__availability__formContainer__locations'>
                  <Filters.Location check={checkFilter} className={'location'} />
                  <Filters.AnotherLocation check={checkFilter} className={'location'} />
                </div>
                <Filters.Times
                  className={'singleVan__availability__formContainer__times'}
                  check={checkFilter}
                  startDate={filters.start_date}
                  endDate={filters.end_date}
                  handleStartDate={setStartDateFilter}
                  handleEndDate={setEndDateFilter}
                />
                <Button
                  onClick={() => setupFilters(filters)}
                  variant='contained'
                  className='host-page__vans__search__button'
                >
                  {isLoading.all ? <CircularProgress size={16} /> : 'GET VANS'}
                </Button>
              </div>
              {Object.keys(vanList).length ? (
                <div className='host-page__vans__list'>
                  {Object.keys(vanList).map(location =>
                    vanList[location].map(van => (
                      <VanCard
                        van={van}
                        key={van.id}
                        errors={errors}
                        isFilterValidate={isFilterValidate}
                        container={container}
                      />
                    ))
                  )}
                </div>
              ) : (
                <div className='host-page__vans__loading'>
                  <CircularProgress size={100} />
                </div>
              )}
            </div> */}
          </div>
        )
      )}
    </div>
  );
};
export default HostPage;
